import React, { Fragment, useState, useEffect } from 'react'
import './CalculTeg.css';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addInstitution, getInstitution, updateInstitution, getInstitutions, getInstitutionsCategoriesCreated } from '../../services/http';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Select, { StylesConfig } from 'react-select';
import question from "../../assets/images/yellow_question.svg"
import { CDN_BASE_URL } from '../../constants/constants';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import Loader from '../../components/Loader/Loader';



const CalculTeg = (props) => {

    const { operationType } = props;

    const navigate = useNavigate();

    const id_institution = useParams()

    const [displayLoader, setDisplayLoader] = useState(false);
    const [processOngoing, setProcessOngoing] = useState(false)

    const [institution, setInstitution] = useState({ libelle: "", category: { value: "", label: "" }, email: "", telephone: "", zones: [], logo: null });

    const [institutionCategories, setInstitutionCategories] = useState([]);

    const [zones, setZones] = useState([{ value: "", label: "" }]);


    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Calcul TEG", secondLevelLink: "/calcul-teg", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("calculTeg", dispatch)
    }, [])






    const [showErrorLibelle, setShowErrorLibelle] = useState(false)
    const [showErrorEmail, setShowErrorEmail] = useState(false)


    const [libelleErrorMessage, setLibelleErrorMessage] = useState("")
    const [emailErrorMessage, setEmailErrorMessage] = useState("")

    const [imgData, setImgData] = useState(null);

    const dispatch = useDispatch();


    const states = useSelector((state) => state, shallowEqual);

    const handleChangeLabel = (key, e) => {
        // var value = e.currentTarget.value;

        // if (key == "libelle") {
        //     setInstitution({ ...institution, libelle: value });
        // }
        // if (key == "email") {
        //     setInstitution({ ...institution, email: value });
        // }

    }


    const handleAddInstitution = async () => {
        setProcessOngoing(true)
        // const reqdata = await addInstitution(institution, states.userToken.access_token);
        // if (reqdata.response && reqdata.response.status !== 200) {
        // if (reqdata.response.status === 422) {
        // setProcessOngoing(false)


        // } else {
        // console.log(reqdata.response?.data.error)
        // toast.error(reqdata.response?.data.message, {
        //     position: toast.POSITION.TOP_RIGHT
        // });
        // }
        // } else {
        // setProcessOngoing(false)
        // toast.success(`Succès !`, {
        // position: toast.POSITION.TOP_RIGHT
        // });


        // }

    }




    // useEffect(() => {
    //     if (institution.libelle !== "") {
    //         setShowErrorLibelle(false)
    //     }
    //     if (institution.email !== "") {
    //         setShowErrorEmail(false)
    //     }    
    // }, [institution])

    const zoneSelection = (e) => {
        // let values = []
        // e.map(a => values.push({ value: a.value, label: a.label }));
        // // console.log("values", typeof values)
        // console.log(values)

        // setInstitution({ ...institution, zones: values })
    }

    const categorySelection = (e) => {
        // setInstitution({ ...institution, category: { value: e.value, label: e.label } })
    }

    const handleFileChoose = (e) => {
        // const value = e.currentTarget.files[0]
        // console.log("value ", value)
        // setImgData(URL.createObjectURL(e.target.files[0]));
        // setInstitution({ ...institution, logo: value })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '35px',
            height: '35px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '35px',
            padding: '0 6px',
            marginTop: '-5px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
            //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '35px',
        }),
    };

    const customStyles2 = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '35px',
            //   height: '35px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            padding: '0 6px',
            //   marginTop: '-5px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
            //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            minHeight: '35px',
        }),
    };

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            {/* <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div> */}
                        </div>
                        {displayLoader == false ?
                            <div id='add-edit-institution' className="widget widget-content widget-content-area mt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 text-left" id="exampleModalLabel">{"Calcul de TEG"}</h5>
                                </div>
                                <hr />

                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Nom du produit"}>Nom du produit</div>
                                        <select id="cat-etablissement-avg" onChange={(e) => console.log("cat-etablissement-avg", e)} className={"form-control custom-form-control basic mb-2 mr-2 "}>
                                            <option disabled selected hidden value=""> </option>
                                            {/* {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))} */}
                                        </select>
                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Objet du prêt"}>Objet du prêt</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>

                                {/* -------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"% d'emprunteurs actifs"}>% d'emprunteurs actifs</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"% de l'encours de crédit brut"}>% de l'encours de crédit brut</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* -------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Méthodologie (prêt individuel ou groupe solidaire)"}>Méthodologie (prêt individuel ou groupe solidaire)</div>
                                        <select id="cat-etablissement-avg" onChange={(e) => console.log("cat-etablissement-avg", e)} className={"form-control custom-form-control basic mb-2 mr-2 "}>
                                            <option disabled selected hidden value=""> </option>
                                            {/* {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))} */}
                                        </select>
                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Devise (selon les symboles internationaux des unités monétaires)"}>Devise (selon les symboles internationaux des unités monétaires)</div>
                                        <select id="cat-etablissement-avg" onChange={(e) => console.log("cat-etablissement-avg", e)} className={"form-control custom-form-control basic mb-2 mr-2 "}>
                                            <option disabled selected hidden value=""> </option>
                                            {/* {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))} */}
                                        </select>                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ------------------------------------------ */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Montant de prêt (min)"}>Montant de prêt (min)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Montant de prêt (le plus fréquent)"}>Montant de prêt (le plus fréquent)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ------------------------------------------------ */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Montant de prêt (max)"}>Montant de prêt (max)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Maturité du prêt en nombre de périodes (min)"}>Maturité du prêt en nombre de périodes (min)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ---------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Maturité du prêt en nombre de périodes (la plus fréquente)"}>Maturité du prêt en nombre de périodes (la plus fréquente)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Maturité du prêt en nombre de périodes (max)"}>Maturité du prêt en nombre de périodes (max)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Fréquence de remboursement"}>Fréquence de remboursement</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Période de grâce (en nombre de remboursements)"}>Période de grâce (en nombre de remboursements)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Garantie en espèces en % du montant de prêt"}>Garantie en espèces en % du montant de prêt</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Méthode de calcul du taux d'intérêt"}>Méthode de calcul du taux d'intérêt</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Taux d'intérêt (annualisé)"}>Taux d'intérêt (annualisé)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Frais initiaux, en % du montant prêté"}>Frais initiaux, en % du montant prêté</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Autres frais additionnels, en % du montant prêté"}>Autres frais additionnels, en % du montant prêté</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Assurance, en % du montant prêté"}>Assurance, en % du montant prêté</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <div className="w-90 mx-auto d-flex mb-3">
                                    <div className="col-sm-6 col-xs-12 mb-2">
                                        <div className={"text-dark truncate text-left"} title={"Autres frais fixes additionnels (montant)"}>Autres frais fixes additionnels (montant)</div>
                                        <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                        {/* {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>} */}

                                    </div>
                                </div>
                                {/* ----------------------------------------------- */}
                                <hr />
                                <div className="new-institution-custom-modal-footer w-90 pb-3">

                                    {processOngoing == false ? <Fragment>
                                        <button type="button"
                                            title={"Enrégistrer"}
                                            className="btn btn-primary ml-3" onClick={() => console.log("Enrégistrer")}>{"Enrégistrer"}</button>

                                    </Fragment> : <ProcessSpinner />}
                                    <button className=" ml-3 btn" data-dismiss="modal" onClick={() => console.log("Back")}><i className="flaticon-cancel-12"></i> Retour</button>
                                </div>
                            </div> : <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>}
                    </div>

                </div>
            </div>
        </div>



    )
}

export default CalculTeg